module.exports = __webpack_public_path__ + "6ae24685b79ffedbab48a859b4e958da.svg";